var map = {
	"./headshot-1.png": 25,
	"./headshot-2.png": 26,
	"./headshot-3.png": 27
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;



//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/headshot\-.*\.png$
// module id = 57
// module chunks = 1